import { Box, Stack, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import NavigateTabBtn from "./NavigateTabBtn";
import { useGetShoppingGuideQuery } from "../../../Store/Slices/rtk";
import { useNavigate } from "react-router-dom";
import { GradientBorderBox } from "../../../Components";

export default function Guide() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [tabs, setTabs] = useState(0);

  const { data, status, isSuccess, isLoading, isError } =
    useGetShoppingGuideQuery();

  const handleChange = (type) => {
    if (type == "right") {
      setTabs(tabs - 1);
    } else {
      setTabs(tabs + 1);
    }
  };
  // useEffect(() => {
  //   if (isError) {
  //     navigate("/");
  //   }
  // }, [isError, navigate, isLoading]);

  return (
    <Stack
      sx={{
        width: "100%",
        maxWidth: "1550px",
        mx: "auto",
        px: { xs: "2rem", md: "4rem" },
        position: "relative",
      }}
    >
      <Box
        mt={"6rem"}
        sx={{
          position: "relative",
          overflow: "hidden",
          maxWidth: "1440px",
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          gap: {
            xs: "30px",
            md: "80px",
            xl: "140px",
          },
          borderRadius: "1rem",
          pt: "0",
          width: "100%",
          zIndex:"10"
        }}
      >
        <Stack
          sx={{
            gap: "16px",
            direction: "rtl",
            minHeight: { xs: "400px", md: "550px", xl: "700px" },
            alignItems: "center",
            pb: { xs: "2rem", xl: "8rem" },
          }}
          spacing={5}
        >
          <Typography
            compoent={"h1"}
            color="rgba(56, 56, 56, 1)"
            variant="h4"
            fontWeight={"bold"}
            textAlign={{ sx: "center", md: "right" }}
            sx={{
              py: "2rem",
              textAlign: "center",
              color: theme.palette.primary.main,
              width: "100%",
            }}
          >
            {/* {data?.data?.sections?.[tabs]?.title || "مرحله " + (tabs+1)} */}
            {data?.data?.sections?.[tabs]?.title || "راهنما"}
          </Typography>
          <Typography
            textAlign={"justify"}
            variant="h6"
            sx={{
              px: "2rem",
              width: "100%",
              whiteSpace: "pre-wrap",
              fontSize: { xs: "1rem", md: "1.2rem" },
            }}
          >
            {data?.data?.sections?.[tabs]?.desc || "راهنمایی یافت نشد !" }
          </Typography>
          {/* {data?.data?.sections?.[tabs]?.image ? (
            <Box
              sx={{
                width: { xs: "90%", md: "70%" },
                height: { xs: "200px", md: "300px", xl: "400px", xxl: "600px" },
                mt: "0",
                borderRadius: "1rem",
                overflow: "hidden",
              }}
            >
              <img
                src={data?.data?.sections?.[tabs]?.image}
                alt="guide image"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            </Box>
          ) : null} */}
        </Stack>
        <GradientBorderBox inside={true} />
      </Box>
      {/* Left And Right Btns , changing tabs handle here */}
      <NavigateTabBtn
        type={"left"}
        handleChange={handleChange}
        selectedTab={tabs}
        maxLength={data?.data?.sections?.length || 1}
      />
      <NavigateTabBtn
        type={"right"}
        handleChange={handleChange}
        selectedTab={tabs}
        maxLength={data?.data?.sections?.length || 1}
      />

      
    </Stack>
  );
}
